
export const LINGOTE = 'LINGOTE'